import React from 'react';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { contactInfo, apartmentInfo } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { href: '#galerija', label: t.nav.gallery },
    { href: '#o-apartmanu', label: t.nav.about },
    { href: '#lokacija', label: t.nav.location },
    { href: '#atrakcije', label: t.nav.attractions },
    { href: '#rezervacija', label: t.nav.reserve },
  ];

  return (
    <footer className="bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-xl font-bold mb-4">
              {apartmentInfo.name}
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t.hero.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-amber-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4">{t.footer.contact}</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <MapPin size={16} className="text-amber-400 flex-shrink-0" />
                {t.location.address}
              </li>
              <li>
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  <Phone size={16} className="text-amber-400 flex-shrink-0" />
                  {contactInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  <Mail size={16} className="text-amber-400 flex-shrink-0" />
                  {contactInfo.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${contactInfo.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors text-sm"
                >
                  <MessageCircle size={16} className="text-amber-400 flex-shrink-0" />
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} {apartmentInfo.name}. {t.footer.rights}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
